import { MessageService } from 'primeng/primeng';
import { publishReplay, refCount } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClientService } from '../httpClient/httpclient.service';
import { SelfScanConf, SelfScanConfDetail } from '../../models/loyalty-selfScan.model';
import { Observable } from 'rxjs/Observable';
import { ListMetadata } from '../../models/list-metadata.model';

@Injectable()
export class LoyaltySelfscanconfService {

  public baseUrl = '/koncentro-loyalty';
  private cachedFields: Observable<any>;

  constructor(
    private http: HttpClientService,
    private srvNotify: MessageService
  ) { }

  get(selfscanId): Observable <SelfScanConf> {
    return this.http.get(this.baseUrl + '/self_scanning/' + selfscanId);
  }

  list (
    offset = null,
    limit = null,
    search?: Array<{ key: string, value: string }>,
    globalSearch?: string,
    sort?: string,
    sort_dir?: number
  ): Observable<{ data: Array<SelfScanConf> , metadata: ListMetadata }> {
    let params = HttpClientService.buildListParams(offset, limit, search, globalSearch, sort, sort_dir);
    // return this.http.getPaged(this.baseUrl + '/self_scanning?'  + params.toString());
    return this.http.getPaged(this.baseUrl + '/self_scanning/getSelfScanningRulesList?'  + params.toString());
  }

  update(selfscan: SelfScanConf): Observable<SelfScanConf> {
    return this.http.put(this.baseUrl + '/self_scanning/' + selfscan.id, selfscan);
  }

  create(selfscan: SelfScanConf): Observable<SelfScanConf> {
    return this.http.post(this.baseUrl + '/self_scanning/', selfscan);
  }

  remove(selfscanId): Observable<SelfScanConf> {
    return this.http.delete(this.baseUrl + '/self_scanning/' + selfscanId)
    .map(res => {        
        this.srvNotify.add({severity: 'info', summary: 'Success', detail: 'Operation success'});
        return res;
      });
  }
  recover(selfscan) {    
    return this.http.put(this.baseUrl + "/self_scanning/recover/" + selfscan.id, selfscan)
      .map(res => {        
        this.srvNotify.add({severity: 'info', summary: 'Success', detail: 'Operation success'});
      });
  }


  getChild(selfscanId): Observable<{ data: Array<SelfScanConfDetail>, metadata: ListMetadata }> {
    return this.http.get(this.baseUrl + '/self_scanning/' + selfscanId + '/detail');
  }

  getFields () {
    if (!this.cachedFields) {
      this.cachedFields = this.http.get(`${this.baseUrl}/schema/SelfScanningRuleDto`).pipe(
        publishReplay(1), // this tells Rx to cache the latest emitted
        refCount() // and this tells Rx to keep the Observable alive as long as there are any Subscribers
      )
    }
    return this.cachedFields;
  }
  


}



// WEBPACK FOOTER //
// ./src/app/services/loyalty/loyalty-selfscanconf.service.ts